export enum ListItemColumnAlignment {
  left = 'left',
  right = 'right'
}

export interface ListItemColumnLine {
  content: string;
  strong?: boolean;
  title?: string;
  truncate?: boolean;
}

export interface ListItemColumnImage {
  src: string;
  alt?: string;
}

export interface ListItemColumn {
  size?: string;
  hideIfNotAdmin?: boolean;
  hiddenSm?: boolean;
  alignSm?: ListItemColumnAlignment;
  image?: ListItemColumnImage;
  lines?: ListItemColumnLine[];
}
export interface ListItem {
  inactive?: boolean;
  isAdmin?: boolean;
  url?: string;
  alignSm?: 'column' | 'row';
  columns: ListItemColumn[];
}
